class XXLVideoHero extends HTMLElement {
  connectedCallback() {
    this._initHashLinks();
    this._initVideoControls();
  }

  _initHashLinks() {
    this.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        const hash = link.getAttribute('href');
        if (!hash || hash === '#') return;
        const target = document.querySelector(hash);
        if (!target) return;
        e.preventDefault();
        e.stopPropagation(); // don't bubble to media click handler
        this._scrollTo(target);
      });
    });
  }

  _scrollTo(target) {
    const headerH =
      parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hh-header-height')) || 0;
    const y = target.getBoundingClientRect().top + window.scrollY - headerH;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  _initVideoControls() {
    const media = this.querySelector('.xxl-video-hero__media');
    const poster = this.querySelector('.xxl-video-hero__poster');
    const playBtn = this.querySelector('.xxl-video-hero__play-btn');
    const adaptiveVideos = this.querySelectorAll('hh-adaptive-video.xxl-video-hero__video');

    if (!media || !adaptiveVideos.length) return;

    const boundVideos = new WeakSet();

    const syncPlayBtn = () => {
      if (!playBtn) return;
      const paused = media.classList.contains('is-paused');
      const label = paused ? playBtn.dataset.labelPlay : playBtn.dataset.labelPause;
      if (label) playBtn.setAttribute('aria-label', label);
    };

    const onPlay = () => {
      poster?.classList.add('is-hidden');
      media.classList.remove('is-paused');
      syncPlayBtn();
    };

    const onPause = () => {
      poster?.classList.remove('is-hidden');
      media.classList.add('is-paused');
      syncPlayBtn();
    };

    const getActiveVideo = () => {
      for (const adaptiveVideo of adaptiveVideos) {
        const video = adaptiveVideo.shadowRoot?.querySelector('#video-element');
        if (video) return video;
      }
      return null;
    };

    const ensureBound = () => {
      const video = getActiveVideo();
      if (!video || boundVideos.has(video)) return video;

      video.addEventListener('play', onPlay);
      video.addEventListener('pause', onPause);
      boundVideos.add(video);

      if (!video.paused) onPlay();
      else onPause();
      return video;
    };

    const togglePlayback = () => {
      const video = ensureBound();
      if (!video) return;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    };

    // Stop all CTA clicks from reaching the media toggle handler
    this.querySelector('.xxl-video-hero__cta')?.addEventListener('click', (e) => e.stopPropagation());

    playBtn?.addEventListener('click', (e) => {
      e.stopPropagation();
      togglePlayback();
    });

    media.addEventListener('click', (e) => {
      if (e.target.closest('a, button')) return;
      togglePlayback();
    });

    const tryBind = () => Boolean(ensureBound());

    if (!tryBind()) {
      const waitForShadow = setInterval(() => {
        if (tryBind()) clearInterval(waitForShadow);
      }, 50);
      setTimeout(() => clearInterval(waitForShadow), 5000);
    }

    // Re-bind when desktop/mobile video swaps on viewport change
    window.matchMedia('(max-width: 749px)').addEventListener('change', () => {
      setTimeout(tryBind, 100);
    });
  }
}

customElements.define('xxl-video-hero', XXLVideoHero);
